import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/icon/close.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong" }, null, -1)
const _hoisted_2 = {
  key: 1,
  class: "order-number-point num-problem-handling"
}
const _hoisted_3 = {
  key: 2,
  class: "order-number-point num-confirm-type"
}
const _hoisted_4 = {
  key: 0,
  class: "abnormalTipsBox flex-cen"
}
const _hoisted_5 = {
  key: 0,
  class: "flex abnormalTips"
}
const _hoisted_6 = { style: {"flex":"1","line-height":"1.2"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: false
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import { ref, Ref, onMounted, computed } from 'vue'
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router'
import { isD2C, useSite } from '@/store'
import ProblemHandling from './ProblemHandling.vue'
import ConfirmType from './ConfirmType.vue'
import ApplyCancel from './ApplyCancel.vue'
import AfterSales from './AfterSales.vue'
import Guide from '@/components/guide/index.vue'
import { t } from '@/plugins/i18n'
import Cookie from 'js-cookie'
import {
  d2cEditableTabs,
  b2bEditableTabs
} from './data'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  refreshTable()
})
onBeforeRouteUpdate((to) => {
  const { query } = to
  abnormal.value = query?.abnormal || 'ProblemHandling'
  refreshTable()
})
const notProcessedOrder = computed(() => store.getters.notProcessedOrder)

const store = useStore()
const editableTabs = computed(() => {
  return store.getters.plat === 'd2c' ? d2cEditableTabs : b2bEditableTabs
})
const router = useRouter()
const { query } = useRoute()

const abnormal: Ref<any> = ref(query?.abnormal || 'ProblemHandling')
const componentsRefs: Ref<any[]> = ref([])

const handleTabClick = () => {
  router.replace({
    query: { abnormal: abnormal.value }
  })
}

const refreshTable = () => {
  componentsRefs.value[abnormal.value].isBatchSearch = false
  componentsRefs.value[abnormal.value].refreshTable(true)
}

const abnormalTipsVisible = ref(false)
const abnormalTipsVisibleCookie = Cookie.get(`abnormalTipsVisibleCookie${store.getters.curShop}`)
if (!abnormalTipsVisibleCookie || (Number(abnormalTipsVisibleCookie) + 86400000) < new Date().getTime()) {
  abnormalTipsVisible.value = true
}
const closeAbnormalTips = () => {
  abnormalTipsVisible.value = false
  Cookie.set(`abnormalTipsVisibleCookie${store.getters.curShop}`, String(new Date().getTime()))
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["abnormal-order abnormal-order-order", _unref(useSite)()])
  }, [
    (_unref(isD2C)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["style-tip-icon", _unref(useSite)()])
        }, [
          _createVNode(_component_el_tooltip, {
            "popper-class": "style-tip-icon-width",
            effect: "light",
            content: _unref(t)('商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认')
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["content"])
        ], 2))
      : _createCommentVNode("", true),
    (_unref(notProcessedOrder)?.abnormalOrderCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(notProcessedOrder)?.abnormalOrderCount > 99 ? '99+' : _unref(notProcessedOrder)?.abnormalOrderCount), 1))
      : _createCommentVNode("", true),
    (_unref(notProcessedOrder)?.deliveryAbnormalOrderCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(notProcessedOrder)?.deliveryAbnormalOrderCount > 99 ? '99+' : _unref(notProcessedOrder)?.deliveryAbnormalOrderCount), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_el_tabs, {
      modelValue: abnormal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((abnormal).value = $event)),
      type: "card",
      class: "demo-tabs",
      onTabClick: handleTabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), (item) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.title,
            name: item.name
          }, {
            default: _withCtx(() => [
              (abnormal.value === 'ProblemHandling' && abnormalTipsVisible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (abnormalTipsVisible.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('遇到需要选择良品入库或次品退货异常需要您确认时，请在72小时内确认，超过72小时系统将自动选择次品退货')) + " " + _toDisplayString(_unref(t)('采购中发起异常，请在60个自然日处理，超时系统将自动处理为取消。')), 1),
                          _createElementVNode("div", {
                            class: "flex-cen-ter",
                            onClick: closeAbnormalTips
                          }, _hoisted_8)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (item.name === 'ProblemHandling')
                ? (_openBlock(), _createBlock(ProblemHandling, {
                    key: 1,
                    ref: (el) => componentsRefs.value[item.name as any] = el
                  }, null, 512))
                : _createCommentVNode("", true),
              (item.name === 'ApplyCancel')
                ? (_openBlock(), _createBlock(ApplyCancel, {
                    key: 2,
                    ref: (el) => componentsRefs.value[item.name as any] = el
                  }, null, 512))
                : _createCommentVNode("", true),
              (item.name === 'AfterSales')
                ? (_openBlock(), _createBlock(AfterSales, {
                    key: 3,
                    ref: (el) => componentsRefs.value[item.name as any] = el
                  }, null, 512))
                : _createCommentVNode("", true),
              (item.name === 'ConfirmType')
                ? (_openBlock(), _createBlock(ConfirmType, {
                    key: 4,
                    ref: (el) => componentsRefs.value[item.name as any] = el
                  }, null, 512))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 3,
          name: "b2b-abnormal-order"
        }))
      : _createCommentVNode("", true),
    (_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 4,
          name: "d2c-abnormal-order"
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})